import { render } from "./AiFooter.vue?vue&type=template&id=75efd8e8"
import script from "./AiFooter.vue?vue&type=script&lang=js"
export * from "./AiFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__